import { Component } from "react";

import ExtratFacture from "../../../models/ExtratFacture";
import SocieteFactureBox from "../../../models/SocieteFactureBox";
import BCService from "../../../services/BC";
import ListAvancePayementBC from "./ListAvancePayementBC";
import MethodePayementBC from "./MethodePayementBC";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SellingService from "../../../services/SellingService";

class PayerAvanceBC extends Component {
  state = {
    bdcInformation: {},
    companyInfo: {},
    productsBC: {},

    // societeCliente: "",
    // societePartner: "",
    // bonCommande: "",
    // extratBill: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      bdcInformation: {},
      companyInfo: {},
      productsBC: {},
      restToPay: 0,
      // societeCliente: "",
      // societePartner: "",
      // bonCommande: "",
      // extratBill: [],
    };
  }

  payementChooseUI() {
    if (this.state.buttonClicked === "clicked") {
      return (
        // <section class="content">
        <div class="row">
          <div class="col-12">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">Première étape: </h3>
                <br />
              </div>

              {/* <div className="card-body"> */}
              <MethodePayementBC idBC={localStorage.getItem("idBC")} />
              {/* </div> */}
            </div>
          </div>
        </div>
        // </section>
      );
    }
  }
  componentDidMount() {
    //  this.forceUpdate();
      BCService.getDocumentForPayementTask(localStorage.getItem("idBC"), "0")
        .then((response) => {
          console.log("response", response.data["success"]);
          if (response.data["success"]) {
            this.setState({
              bdcInformation: response.data["success"],
            });
            this.setState({
              companyInfo: response.data["company"],
            });
            this.setState({
              productsBC: response.data["purchases"],
            });
            console.log(response.data["success"]);
            if (response.data["success"]?.finalPriceHT) {
              this.setState({ totalHT: response.data["success"].finalPriceHT });
            } else {
              this.setState({ totalHT: response.data["success"].buyinfPrice });
            }
            if (response.data["success"]?.finalPriceTT) {
              this.setState({ totalTT: response.data["success"].finalPriceTt });
            } else {
              this.setState({ totalTT: response.data["success"].priceTT });
            }
            if (response.data["success"]?.restToPay) {
              this.setState({ restToPay: response.data["success"].restToPay });
            }

            // this.setState({
            //   societeCliente: response.data["BCExtrat"].societeCliente,
            // });
            // this.setState({
            //   societePartner: response.data["BCExtrat"]["societePartner"],
            // });
            // this.setState({
            //   bonCommande: response.data["BCExtrat"]["bc"],
            // });
            // this.setState({
            //   extratBill: response.data["BCExtrat"]["extracts"],
            // });
          }
        })
        .catch((error) => {
          this.setState({ alert_message: "error" });
        });
      BCService.getFacturePayementInformation(
        localStorage.getItem("idBC"),
        "BDC"
      )
        .then((response) => {
          if (response.data["Payement"]) {
            console.log("payementInformations", response.data["Payement"]);

            this.setState({
              payementInformations: response.data["Payement"],
            });
            if (response.data["Payement"]?.id != null) {
              this.setState({
                restToPay: response.data["Payement"]?.restToPay,
              });
            }
          } else if (response.data["PayementTotal"]) {
            this.setState({
              totalPayementInformation: response.data["PayementTotal"],
            });
          }
        })
        .catch((error) => {
          this.setState({ alert_message: "error" });
        });
    
   
  }

  getAvancesPayementBC() {
    return <ListAvancePayementBC idBC={localStorage.getItem("idBC")} />;
  }
 
  formatDate(date) {
    var cdate = new Date(date);
    var day = String(cdate.getDate()).padStart(2, "0");
    let month = String(cdate.getMonth() + 1).padStart(2, "0");
    let year = cdate.getFullYear();
    return day + "/" + month + "/" + year;
  }
  finaliserBill = (e) => {
    BCService.finaliserPayement(0, localStorage.getItem("idBC"))
      .then((response) => {
        console.log(response);
        if (response.data.error) {
          toast.error("Error : il ya un probléme");
        } else {
          toast.success("Opération avec succès");

          this.refreshPage();
        }
      })
      .catch((error) => {
        toast.error("Error : il ya un probléme");

        this.refreshPage();
      });
  };
  refreshPage() {
    window.location.reload(false);
  }
  buttonFinaliserPayement(e) {
    console.log("this.state.bill.payed", this.state.bdcInformation);
    if (this.state.bdcInformation?.payed === 1) {
    } else {
      return (
        <button
          type="submit"
          onClick={(e) => {
            this.finaliserBill();
            // this.setState({ buttonClicked: "clicked" });
          }}
          className="btn btn-dark float-right"
        >
          Finaliser le payement
        </button>
      );
    }
  }

  render() {
    return (
      <div className="content-wrapper" style={{ marginTop: "0" }}>
        <div class="container-fluid">
          <br />

          <section className="invoice p-3 mb-3">
            <div className="col-xs-12">
              <h2 className="page-header">
                <i className="fas fa-globe-africa" />
                {this.state.bdcInformation.title}
                <small className="float-right">
                  Date:{" "}
                  {this.formatDate(this.state.bdcInformation.createionDate)}
                </small>
              </h2>
            </div>
          
            <div className="row invoice-info">
              <div className="col-sm-6 invoice-col">
                Détails Bon de commande Achat
                <address>
                  <strong>
                    {this.state.bdcInformation.ref}-
                    {this.state.bdcInformation.title}
                  </strong>
                  <br />
                  {this.state.bdcInformation.note != null
                    ? this.state.bdcInformation.note
                    : "Vide"}
                  {/* <br />
                  {this.state.bonCommande.description} */}
                  <br />
                </address>
              </div>
              <SocieteFactureBox
                societe={this.state.companyInfo}
                role="Emetteur"
              />
              <SocieteFactureBox
                societe={this.state.bdcInformation?.supplier}
                role="Fournisseur"
              />
            </div>
            <div className="row">
              <div class="col-6"></div>

              <div class="col-6">
                <ExtratFacture extracts={this.state.bdcInformation.purchases} />
              </div>
            </div>
            <div className="row">
              <div class="col-6"></div>

              <div className="col-6">
                <div className="table-responsive">
                  <table className="table">
                    <tbody>
                      <tr>
                        <th style={{ width: "50%" }}>Total HT:</th>
                        <td>{this.state.totalHT} DNT</td>
                      </tr>
                      {/* <tr>
                        <th>TVA</th>
                        <td>{this.state.bonCommande.tva} DNT</td>
                      </tr> */}
                      {/* <tr>
                        <th>Timbre:</th>
                        <td>
                          {this.state.bdcInformation.supplier?.timbre} DNT
                        </td>
                      </tr> */}
                      <tr>
                        <th>Total TT:</th>
                        <td>{this.state.totalTT} DNT</td>
                      </tr>
                      <tr>
                        <th>Reste à payer:</th>
                        <td>{this.state.restToPay} DNT</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="box-footer"></div>
            <br />
            <br />
          </section>
          {this.getAvancesPayementBC()}
          <button
            type="submit"
            onClick={(e) => {
              this.setState({ buttonClicked: "clicked" });
            }}
            className="btn btn-dark float-right"
          >
            Payer avance
          </button>
          <br />
          <br />
          {this.buttonFinaliserPayement()}
          <br />
          <br />
          {this.payementChooseUI()}
        </div>
      </div>
    );
  }
}
export default PayerAvanceBC;
